import cn from "classnames";
import type {AppTooltipProps} from "./Tooltip.types";
import styles from "./Tooltip.module.scss";

export const getOverlayClassNames = (props: AppTooltipProps) => {
  return cn(styles.tooltip, props.color && styles[`color-${props.color}`], props.overlayClassName);
};